import React, { Component } from 'react';

//React-PDF dependencies
import { Text, View, StyleSheet } from "@react-pdf/renderer";

const styles = StyleSheet.create({
  SmokeText: {
    display: 'inline-flex',
    flexDirection: 'column',
    fontSize: 16,
    width: '20%',
    height: 40,
    position: 'relative',
    label: {
      fontSize: 10,
      color: '#000000',
      opacity: 0.3,
      paddingTop: 16,
      fontFamily: 'Roboto',
    },
    input: {
      fontSize: 12,
      fontFamily: 'Roboto',
    },
  },
  smokeTestContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    marginBottom: 10,
    column: {
      display: 'flex',
      flexDirection: 'row',
    },
  },
});

const SmokeText = ({ children, ...props }) => (
  <View style={styles.SmokeText}>
    <Text style={styles.SmokeText.label} {...props}>
      {props.label}
    </Text>
    <Text style={styles.SmokeText.input} {...props}>
      {children}
    </Text>
  </View>
);

class SmokeTestPdf extends Component {
  render() {
    return (
      <View style={styles.smokeTestContainer}>
        <View style={styles.smokeTestContainer.column}>
          <SmokeText label={"Enclosure"}> {this.props.smokeTest.enclosure.name} </SmokeText>
          <SmokeText label={"Company"}> {this.props.smokeTest.company}  </SmokeText>
          <SmokeText label={"Name of Witness"}> {this.props.smokeTest.nameOfWitness} </SmokeText>
          <SmokeText label={"Date"}> {this.props.smokeTest.date} </SmokeText>
          <SmokeText label={"Time"}> {this.props.smokeTest.time} </SmokeText>
        </View>
      </View>
    );
  }
}

export default SmokeTestPdf;



// WEBPACK FOOTER //
// src/components/innerComponents/pdfComponents/SmokeTestPdf.js